<template>
  <div class="alliance">
    <div class="alliance_bg"></div>

    <div class="alliance-text text">
      <h2 class="text-title">WR1 ALLIANCE</h2>
      <p>Diversity inspires us, our culture connects us.</p>
      <p>
        Our modern, inclusive workplaces are filled with amazing individuals who
        share our values and vision to go all the way.
      </p>

      <p>All the way for our customers, our company and each other.</p>
      <a href="" class="more"
        >Learn more <img src="@/assets/images/alliance/arrow.png" alt=""
      /></a>
    </div>
    <div class="bg-rote"></div>
    <img class="img-ali" src="@/assets/images/alliance/wr1-3.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "Alliance",
};
</script>

<style lang="scss" scoped>
.alliance {
  position: relative;
  min-height: 600px;

  &_bg {
    background: url("../../../../../assets/images/alliance/bg-alliance.png")
      no-repeat;
    background-size: 100% 100%;
    background-position: center;
    width: 100%;
    right: 0;
    height: 100%;
    position: absolute;
    z-index: 1;
  }
  .text {
    position: absolute;
    left: 7%;
    top: 0;
    z-index: 3;
    padding: 20px;
    border-radius: 20px;
    background-color: #2b938c;
    margin-top: 70px;
    margin-bottom: 150px;
    width: 500px;
    color: #fff;
    &-title {
      font-weight: 800;
      font-size: 3.2rem;
      line-height: 5.3rem;
      letter-spacing: -0.02em;
      color: inherit;
      padding-bottom: 50px;
    }
    p {
      font-size: 1.2rem;
      line-height: 2.35rem;
      letter-spacing: -0.02em;
      padding-bottom: 10px;
    }
    .more {
      font-style: italic;
      font-weight: normal;
      font-size: 1rem;
      line-height: 2.1rem;

      letter-spacing: -0.02em;

      color: #ffffff;
      img {
        width: 10px;
        height: 10px;
        margin-left: 5px;
      }
    }
  }
  @media (width: 1024px) {
    .text {
      background-color: hsla(24, 100%, 97%, 0) !important;
    }
    &_bg {
      width: 66% !important;
    }
    .bg-rote {
      display: block !important;
      right: -30% !important;
    }
    .img-ali {
      display: block;
    }
  }

  @media (width: 1440px) {
    .text {
      background-color: hsla(24, 100%, 97%, 0) !important;
    }
    &_bg {
      width: 77% !important;
    }
    .bg-rote {
      display: block !important;
      right: 9% !important;
    }
    .img-ali {
      display: block;
    }
  }

  @media (min-width: 2560px) {
    .text {
      background-color: hsla(24, 100%, 97%, 0) !important;
    }
    &_bg {
      background: url("../../../../../assets/images/alliance/bg-alliance.png")
        no-repeat;
      background-size: 100% 100%;
      background-position: center;
      width: 84%;
      right: 0;
      height: 100%;
      position: absolute;
      z-index: 1;
    }
    .bg-rote {
      display: block !important;
    }
    .img-ali {
      display: block;
    }
  }

  .bg-rote {
    display: none;
    background-color: #2b938c;
    background-size: 100% 100%;
    color: #333;
    top: 31.6%;
    right: 44%;
    width: 1300px;

    height: 600px;
    position: absolute;
    z-index: 2;
    border-radius: 500px;
    transform: translateX(-50%) rotateZ(147deg);
  }
  .img-ali {
    display: none;
    width: 300px;
    transform: rotateZ(12deg);
    margin-right: 129px;
    margin: top;
    z-index: 999;
    bottom: -40%;
    position: absolute;
  }
}
</style>